import React, { Component, useState } from 'react';
import { Translation } from "react-i18next";
import { TFunction } from "i18next";
import { insertHtml } from "../../../utils/dom";
import { isMobileOnly } from "react-device-detect";
import "./home_page_desktop_message.scss";


class HomePageDesktopMessage extends Component<any, { visible: boolean }> {

    constructor(props: any) {
        super(props);
        this.state = { visible: true };

        // Necessario per accedere al corretto valore di `this` all'interno della callback
        this.hideBanner = this.hideBanner.bind(this);
    }

    hideBanner() {
        this.setState(prevState => ({
            visible: !prevState.visible
        }));
    }

    render() {
        let aosProps = {
            "data-aos": "fade-right",
            "data-aos-offset": 0,
            "data-aos-delay": 0,
            "data-aos-duration": 0,
            "data-aos-easing": "ease-in-out",
            "data-aos-mirror": false,
            "data-aos-once": true
        };
        // let test = document.getElementById('container-banner-mob');
        // let x = document.getElementById('banner');

        // if (test) {
        //     test.onclick = function () { console.log("TESTE") };
        // }

        //if (x) { x.style.display = "none" }



        return (
            // <a href={this.props.lang === 'it' ? 'https://www.luiss.it/ammissione/ammissione-magistrali/test-ammissione-magistrali' : 'https://www.luiss.edu/selection-for-gaokao-students-bachelor'}>
            //     {/* <div className={this.props.lang === 'it' ? 'home-page-message-it' : 'home-page-message-en'} {...aosProps}> */}
            //     <div className={this.props.lang === 'it' ? 'home-page-message-it' : ''} {...aosProps}>
            //         <Translation>
            //             {(t: TFunction) => (
            //                 <a className="home-page-overlay ovveride-banner" href={t("HOME PAGE message link")}>
            //                     <h3 className="message-title">{t("HOME PAGE message title")}</h3>
            //                     <p className="message-content" {...insertHtml(t("HOME PAGE message content"))} />
            //                     <p className="message-footer">{t("HOME PAGE message footer")}</p>
            //                 </a>
            //             )}
            //         </Translation>
            //     </div>
            // </a>
            <>
                {!isMobileOnly ?
                    <div className='container-banner'>
                        {this.props.banners.map((data: any) => (
                            data.published === true &&
                            <div className="row banner">
                                <div className="col-2 p-0 image-container">
                                    <img src={data.image} alt={data.title}></img>
                                </div>
                                <div className="col-2 title">
                                    {data.title}
                                </div>
                                <div className="col-6 col-xl-7 body">
                                    <span {...insertHtml(data.body!)} />
                                </div>
                                <a className="col-2 col-xl-1 iscriviti" href={data.cta_url}>
                                    {data.cta_label}
                                </a>
                            </div>
                        ))}
                    </div>
                    :
                    this.state.visible &&
                    <div className='container-banner-mob'>
                        {this.props.banners.map((data: any, i: any) => (
                            data.published === true &&
                            <div className="banner"  key={i}>
                                <span className="x-close" onClick={this.hideBanner}></span>
                                <div className="title">
                                    {data.title}
                                </div>
                                <div className="body">
                                    <span {...insertHtml(data.body!)} />
                                </div>
                                <a className="iscriviti" href={data.cta_url}>
                                    <p>{data.cta_label}</p>
                                </a>
                            </div>
                        ))}
                    </div>
                }

            </>
        );
    }
}

export default HomePageDesktopMessage;
